
import DesignTokens from '@tableau/design-tokens';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { applyColor }from '~src/style/ColorService';

export namespace ManageDataAlertRecipientsDialogStyles {

  export const STYLE: React.CSSProperties = {
      position: 'relative',
      height: '300px'
  };

  export const LIST_BOX_STYLE: React.CSSProperties = {
    borderWidth: CommonStyles.Sizes.TextBoxBorderSize,
    borderColor: applyColor(DesignTokens.color.elevation.border.default.default, CommonStyles.Colors.BorderColor),
    borderStyle: 'solid'
  };
}